<template>
    <div class="cabinet-content-wrap">
        <header class="cabinet-header flex flex-align-center">
            <h1 class="h1 cabinet-title">Заказы</h1>
        </header>

        <order-list :page-sizes="[10, 20, 50, 100]" />
    </div>
</template>

<script>
import OrderList from '../../../components/Cabinet/Retailer/Orders/OrderList'

export default {
    name: 'RetailerOrders',
    components: {
        OrderList
    }
}
</script>
